import {
  FeatureFlag,
  useFeatureFlag,
} from "@vega-api/extended/auth/useFeatureFlag";
import { useNotificationsStream } from "@vega-modules/scenes/Notifications/useNotificationsStream";

import { COINVEST_NOTIFICATION_PUBLISHER } from "../../constants/notificationConstants";

export const CoInvestNotificationsStreamRunner = () => {
  const { featureFlag } = useFeatureFlag();
  useNotificationsStream({
    enabled:
      featureFlag[FeatureFlag.COINVEST_NOTIFICATIONS] ||
      featureFlag[FeatureFlag.COINVEST_MESSAGING_VD_28584],
    publisher: COINVEST_NOTIFICATION_PUBLISHER,
    showToast: false,
  });

  return null;
};
